











import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
@Component
export default class FilterBox extends Vue {
    private eventEmit = {
        eventFilterChange: 'eventFilterChange'
    };

    searchText = '';

    onTextSearchChange() {
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText
        });
    }
}
